import { render } from "./DashboradPage.vue?vue&type=template&id=2fa44ead"
import script from "./DashboradPage.vue?vue&type=script&lang=js"
export * from "./DashboradPage.vue?vue&type=script&lang=js"

import "./DashboradPage.vue?vue&type=style&index=0&id=2fa44ead&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__